import React from 'react';
import styles from './ProfileTemplate.module.scss';
import PersonalInfo from 'component/molecules/profile/personalInfo/PersonalInfo';
import Usage from 'component/molecules/profile/Usage/Usage';
import { useFetch } from 'hooks/useFetch';
import { userEndpoints } from 'hooks/endpoints';
import LoadingSpinner from 'component/Custom/LoadingSpinner/LoadingSpinner';
import { usePost } from 'hooks/usePost';

const ProfileTemplate = () => {
  const {
    data: data,
    isFetching: isFetching,
    refetch: refetchUser,
  } = useFetch(['userAuth'], userEndpoints?.getAuthUser());
  const user = data?.data;

  if (isFetching) {
    return <LoadingSpinner showSpinner />;
  }
  return (
    <div className={styles.profileCont}>
      <PersonalInfo user={user} refetchUser={refetchUser} />
      <Usage user={user} />
    </div>
  );
};

export default ProfileTemplate;
